import React, { useContext, useRef, useState } from 'react';
import { styled } from '@mui/material/styles';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import { Card, CardContent, MenuItem, Table, TableBody, TableCell, TableHead, TableRow } from '@mui/material';

import ListItemText from '@mui/material/ListItemText';
import { Link as RouterLink } from 'react-router-dom';
import { AppContext } from '@/AppContext';
import { renderBadgePDF_ToDataUrl } from '../../../../BadgeDetails/components/BadgeView/BadgeView';
import { saveAs } from 'file-saver';
import DropDownMenu from '@/components/DropDownMenu/DropDownMenu';
import PrintVisitors from '../../../../VisitorList/components/VisitorsToolbar/PrintVisitors';
import ColorPicker from 'components/ColorPicker/ColorPicker';
import { HelpHint } from 'components/HelpHint/HelpHint';
import moment from 'moment';
import Typography from '@mui/material/Typography';
import { shortenTime } from '../../../../MeetupList/components/MeetupsTable/MeetupsTable';

const PREFIX = 'TimeSlotsTable';

const classes = {
  root: `${PREFIX}-root`,
  content: `${PREFIX}-content`,
  inner: `${PREFIX}-inner`,
  nameContainer: `${PREFIX}-nameContainer`,
  avatar: `${PREFIX}-avatar`,
  actions: `${PREFIX}-actions`,
  fab: `${PREFIX}-fab`,
  hint: `${PREFIX}-hint`,
};

const StyledCard = styled(Card)(({ theme }) => ({
  [`&.${classes.root}`]: {
    overflowX: 'auto',
  },

  [`& .${classes.content}`]: {
    padding: 0,
  },

  [`& .${classes.inner}`]: {
    minWidth: 600,
  },

  [`& .${classes.nameContainer}`]: {
    display: 'flex',
    alignItems: 'center',
  },

  [`& .${classes.avatar}`]: {
    marginRight: theme.spacing(2),
  },

  [`& .${classes.actions}`]: {
    justifyContent: 'flex-end',
  },

  [`& .${classes.fab}`]: {
    margin: theme.spacing(1),
  },

  [`& .${classes.hint}`]: {
    marginLeft: 10,
    height: 16,
    width: 16,
    minHeight: 16,
  },
}));

const TimeSlotsTable = props => {
  const { className, meetupId, timeSlots, handleDelete, ...rest } = props;

  if (!timeSlots) {
    return null;
  }

  return (
    <StyledCard {...rest} className={clsx(classes.root, className)}>
      <CardContent className={classes.content}>
        <div className={classes.inner}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Время</TableCell>
                <TableCell>Название</TableCell>
                <TableCell>Зал/Место</TableCell>
                <TableCell>Спикеры</TableCell>
                <TableCell></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {timeSlots.map((timeSlot, i) => (
                <TableRow className={classes.tableRow} hover key={timeSlot.timeSlotId}>
                  <TableCell>
                    <RouterLink to={'/m/' + meetupId + '/program/time-slot/id/' + timeSlot.timeSlotId}>
                      <ListItemText
                        primary={shortenTime(timeSlot.startTime)}
                        secondary={moment(timeSlot.endTime).diff(moment(timeSlot.startTime), 'minutes') + 'мин'}
                      />
                    </RouterLink>
                  </TableCell>
                  <TableCell>
                    <RouterLink to={'/m/' + meetupId + '/program/time-slot/id/' + timeSlot.timeSlotId}>
                      <Typography style={{ fontWeight: 'bold' }}>{timeSlot.name}</Typography>
                    </RouterLink>
                  </TableCell>
                  <TableCell>
                    <Typography>{timeSlot.hall && timeSlot.hall.name}</Typography>
                  </TableCell>
                  <TableCell>
                    {timeSlot.speakers.map(s => (
                      <Typography>{s.firstName + ' ' + s.lastName}</Typography>
                    ))}
                  </TableCell>
                  <TableCell style={{ textAlign: 'center', width: '100px' }}>
                    <DropDownMenu data-test-id='time-slot-menu'>
                      <MenuItem>
                        <RouterLink
                          to={'/m/' + meetupId + '/program/time-slot/id/' + timeSlot.timeSlotId}
                          data-test-id='time-slot-menu-edit'
                        >
                          <ListItemText primary='Редактировать' />
                        </RouterLink>
                      </MenuItem>
                      <MenuItem
                        onClick={() => handleDelete(meetupId, timeSlot.timeSlotId)}
                        data-test-id='time-slot-menu-delete'
                      >
                        <ListItemText primary='Удалить' />
                      </MenuItem>
                    </DropDownMenu>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </CardContent>
    </StyledCard>
  );
};

TimeSlotsTable.propTypes = {
  className: PropTypes.string,
  timeSlots: PropTypes.array.isRequired,
  handleDelete: PropTypes.func,
};

export default TimeSlotsTable;
